var _defs, _path, _rect, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10090IconServiceDataLakeStorageGen1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bfbb91d2-cb20-44cf-b1a9-0d16204a32d7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab3b8b9f-732a-4d4f-a164-b86d9fbe1f71",
    x1: 9.24,
    y1: 0.96,
    x2: 8.85,
    y2: 16.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#31d0f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2cc3e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#25afd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#1c92ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-storage-90") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1,3.6H9.69a.34.34,0,0,1-.22-.07L7.35,2.12a.43.43,0,0,0-.22-.06H.9a.4.4,0,0,0-.4.39v13.1a.4.4,0,0,0,.4.39H17.1a.4.4,0,0,0,.4-.39V4A.4.4,0,0,0,17.1,3.6Z",
    fill: "#005ba1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.05,
    y: 2.82,
    width: 3.86,
    height: 0.77,
    rx: 0.16,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.05,
    y: 2.82,
    width: 0.77,
    height: 0.77,
    rx: 0.11,
    fill: "#1ac3f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1,3.58H9a.36.36,0,0,0-.28.12L7.37,5a.43.43,0,0,1-.28.11H.9a.4.4,0,0,0-.4.4v10a.4.4,0,0,0,.4.39H17.1a.4.4,0,0,0,.4-.39V4A.4.4,0,0,0,17.1,3.58Z",
    fill: "url(#ab3b8b9f-732a-4d4f-a164-b86d9fbe1f71)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.18,5.7a.15.15,0,0,0-.08,0s-.09,0-.13.07L6.81,10.36a.16.16,0,0,0,0,.16.19.19,0,0,0,.15.1H8.83L8,13.4a.13.13,0,0,0,.07.18.1.1,0,0,0,.07,0c.06,0,.09,0,.13-.07l3.26-4.66s0-.06,0-.1a.17.17,0,0,0-.17-.16h-2l.81-2.73A.13.13,0,0,0,10.18,5.7Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10090IconServiceDataLakeStorageGen1);
export default __webpack_public_path__ + "static/media/10090-icon-service-Data-Lake-Storage-Gen1.a234c4d626885af3f2bb4ee6cf2a5dab.svg";
export { ForwardRef as ReactComponent };